<template>
  <div class="px-4 sm:px-6 lg:px-8 bg-white py-6 rounded-lg shadow-sm h-full overflow-auto">
    <div class="sm:flex sm:items-center">
      <div class="sm:flex-auto">
        <h1 class="text-xl font-semibold text-gray-900">Caixa de Entrada - Portal do Cliente</h1>
        <p class="mt-2 text-sm text-gray-700">Todas as solicitações abertas pelos clientes do portal.</p>
      </div>
      <div class="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
        <button @click="carregar" type="button" class="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none sm:w-auto">
          Recarregar
        </button>
      </div>
    </div>
    
    <div class="mt-8 flex flex-col">
      <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
          <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
            
            <table class="min-w-full divide-y divide-gray-300">
              <thead class="bg-gray-50">
                <tr>
                  <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">Data</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Cliente</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Tipo/Assunto</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Descrição</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Status</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Responsável</th>
                  <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-6">
                    <span class="sr-only">Ações</span>
                  </th>
                </tr>
              </thead>
              
              <tbody class="divide-y divide-gray-200 bg-white" v-if="!loading">
                <tr v-for="sol in solicitacoes" :key="sol.id">
                  <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm text-gray-500 sm:pl-6">
                    {{ new Date(sol.created_at).toLocaleDateString('pt-BR') }}
                  </td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm font-medium text-gray-900">
                    {{ sol.user ? sol.user.name : 'Desconhecido' }} <br>
                    <span class="text-xs text-gray-500">{{ sol.user ? sol.user.email : '-' }}</span>
                  </td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{ sol.tipo_solicitacao }}</td>
                  <td class="px-3 py-4 text-sm text-gray-500">
                    <div class="max-w-xs truncate" :title="sol.descricao">{{ sol.descricao }}</div>
                  </td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm">
                    <span class="inline-flex rounded-full px-2 text-xs font-semibold leading-5" 
                          :class="{'bg-yellow-100 text-yellow-800': sol.status === 'aberta', 'bg-blue-100 text-blue-800': sol.status === 'em_andamento', 'bg-green-100 text-green-800': sol.status === 'concluida', 'bg-gray-100 text-gray-800': sol.status === 'cancelada'}">
                      {{ sol.status.toUpperCase() }}
                    </span>
                  </td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    <span v-if="sol.atendente_email">{{ sol.atendente_email }}</span>
                    <span v-else class="text-xs text-red-500 italic">Sem responsável</span>
                  </td>
                  <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                    <!-- Botões de Ação -->
                    <button v-if="!sol.atendente_email && sol.status !== 'cancelada'" @click="assumir(sol.id)" class="text-indigo-600 hover:text-indigo-900 mr-3">
                      Assumir
                    </button>
                    
                    <button v-if="sol.status === 'em_andamento'" @click="concluir(sol.id)" class="text-green-600 hover:text-green-900 mr-3">
                      Concluir
                    </button>
                    
                    <button v-if="sol.status !== 'concluida' && sol.status !== 'cancelada'" @click="cancelar(sol.id)" class="text-red-600 hover:text-red-900">
                      Cancelar
                    </button>
                  </td>
                </tr>
                <tr v-if="solicitacoes.length === 0">
                  <td colspan="7" class="px-3 py-4 text-center text-sm text-gray-500">Nenhuma solicitação encontrada na caixa de entrada.</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="7" class="px-3 py-4 text-center text-sm text-gray-500">Carregando dados...</td>
                </tr>
              </tbody>
            </table>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SolicitacoesClientesRepository from '@/services/SolicitacoesClientesRepository.vue';
import Swal from 'sweetalert2';

export default {
    name: 'SolicitacoesClientesAdminView',
    data() {
        return {
            loading: true,
            solicitacoes: [],
            service: new SolicitacoesClientesRepository(),
            meuToken: ''
        };
    },
    async mounted() {
        // Traz as const globais do User (Admin) logado.
        const userStr = window.localStorage.getItem('myUser');
        if (userStr) {
            const myUser = JSON.parse(userStr);
            this.meuToken = myUser.token; // O token JWT da API Interna
            await this.carregar();
        }
    },
    methods: {
        async carregar() {
            this.loading = true;
            try {
                const res = await this.service.getTodas(this.meuToken);
                this.solicitacoes = res.data;
            } catch (error) {
                console.error("Erro", error);
            } finally {
                this.loading = false;
            }
        },
        async assumir(id) {
            try {
                await this.service.assumirSolicitacao(this.meuToken, id);
                Swal.fire('Beleza!', 'Você assumiu a requisição', 'success');
                this.carregar();
            } catch (err) {
                Swal.fire('Ops', 'Erro ao assumir', 'error');
            }
        },
        async concluir(id) {
            try {
                await this.service.updateStatus(this.meuToken, id, 'concluida');
                this.carregar();
            } catch (err) {
                Swal.fire('Ops', 'Erro', 'error');
            }
        },
        async cancelar(id) {
            try {
                await this.service.updateStatus(this.meuToken, id, 'cancelada');
                this.carregar();
            } catch (err) {
                Swal.fire('Ops', 'Erro', 'error');
            }
        }
    }
}
</script>
